import { render } from "./DefaultAuthor.vue?vue&type=template&id=7d4753e3"
import script from "./DefaultAuthor.vue?vue&type=script&lang=js"
export * from "./DefaultAuthor.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__